import { t } from "@lingui/core/macro";

import { SubscriptionToStatus } from "@/generated/api/users";

const getLocalizedSubscriptionStatus = (): Record<
  SubscriptionToStatus,
  string
> => ({
  ACTIVE: t({ context: "subscription status", id: "Aktivní" }),
  AWAITING_PAYMENT: t({ context: "subscription status", id: "Čeká na platbu" }),
  CANCELLED: t({ context: "subscription status", id: "Zrušeno" }),
  DELETED: t({ context: "subscription status", id: "Smazáno" }),
  EXPIRED: t({ context: "subscription status", id: "Vypršela platnost" }),
  INCOMPLETE: t({ context: "subscription status", id: "Neúplné" }),
  PAST_DUE: t({ context: "subscription status", id: "Po splatnosti" }),
});

export { getLocalizedSubscriptionStatus };
